import StyledButton from "../../components/styled/StyledButton";
import { useNavigate } from "react-router-dom";
import Paths from "../../constants/paths";

const ResetPasswordSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-brand600 flex min-h-screen w-screen items-center justify-center">
      <div className="mx-4 flex flex-col items-center gap-4 rounded-2xl bg-white px-6 py-6 md:min-h-[500px] md:min-w-[600px] md:gap-16 md:px-16 md:py-12">
        <img src="/images/pelican-logo.png" className="h-32 w-32" />
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-center text-3xl font-medium text-black">Succès</h1>
          <p className="text-center text-sm text-gray-600">
            Votre mot de passe a bien été réinitialisé
          </p>
        </div>

        <div className="flex w-full flex-col gap-2">
          <StyledButton onClick={() => navigate(Paths.auth.login)}>Retour à l’accueil</StyledButton>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordSuccessPage;
